/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientOnboardingInviteFreelancerJobStep = {
    NotStarted: 'NOT_STARTED',
    InviteFreelancer: 'INVITE_FREELANCER',
    Done: 'DONE'
} as const;
export type ClientOnboardingInviteFreelancerJobStep = typeof ClientOnboardingInviteFreelancerJobStep[keyof typeof ClientOnboardingInviteFreelancerJobStep];


export function instanceOfClientOnboardingInviteFreelancerJobStep(value: any): boolean {
    for (const key in ClientOnboardingInviteFreelancerJobStep) {
        if (Object.prototype.hasOwnProperty.call(ClientOnboardingInviteFreelancerJobStep, key)) {
            // @ts-ignore
            if (ClientOnboardingInviteFreelancerJobStep[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientOnboardingInviteFreelancerJobStepFromJSON(json: any): ClientOnboardingInviteFreelancerJobStep {
    return ClientOnboardingInviteFreelancerJobStepFromJSONTyped(json, false);
}

export function ClientOnboardingInviteFreelancerJobStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOnboardingInviteFreelancerJobStep {
    return json as ClientOnboardingInviteFreelancerJobStep;
}

export function ClientOnboardingInviteFreelancerJobStepToJSON(value?: ClientOnboardingInviteFreelancerJobStep | null): any {
    return value as any;
}

